import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Star, CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { SatisfactionForm } from '../pages/rapports/SatisfactionForm';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Questionnaire de satisfaction d'un portail (candidat | entreprise) pour une action donnée
export const SatisfactionPortailPanel = ({ portail, dossierId, viewAs, defaultOpen = false }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(defaultOpen);
  const [saving, setSaving] = useState(false);
  const params = viewAs ? { view_as: viewAs } : {};
  const url = `${API_URL}/portail/${portail}/satisfaction/${dossierId}`;
  const load = useCallback(() => axios.get(url, { params }).then(r => setData(r.data)).catch(() => {}), [url, viewAs]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  if (!data || data.questions.length === 0) return null;
  const done = !!data.reponse;
  const submit = async (reponses) => {
    setSaving(true);
    try { await axios.post(url, { reponses }, { params }); toast.success('Merci ! Vos réponses ont été enregistrées'); setOpen(false); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erreur lors de l\'enregistrement'); } finally { setSaving(false); }
  };
  return (
    <div className={`rounded-xl border ${done ? 'border-emerald-200 bg-emerald-50/40' : 'border-amber-200 bg-amber-50/40'}`} data-testid={`satisfaction-panel-${dossierId}`}>
      <button type="button" onClick={() => setOpen(o => !o)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left" data-testid={`satisfaction-toggle-${dossierId}`}>
        <span className="flex items-center gap-2 text-sm font-medium text-slate-800">
          {done ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> : <Star className="w-4 h-4 text-amber-500" />}
          {done ? 'Questionnaire de satisfaction complété' : 'Questionnaire de satisfaction à compléter'}
          {done && data.reponse.date && <span className="text-xs text-slate-500 font-normal">— le {new Date(data.reponse.date).toLocaleDateString('fr-FR')}</span>}
        </span>
        <span className="flex items-center gap-2 text-xs text-slate-500">{done ? 'Modifier' : 'Répondre'} {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 border-t border-slate-200/60 pt-4">
          <SatisfactionForm questions={data.questions} initial={data.reponse?.reponses} onSubmit={submit} saving={saving} />
          {done && <Button variant="ghost" size="sm" className="mt-2 text-xs" onClick={() => setOpen(false)}>Fermer</Button>}
        </div>
      )}
    </div>
  );
};
